import React from 'react';
import { Link } from 'react-router-dom';
import ProjectGrid from '../components/projectGrid';
import ReachMe from '../components/reach-me';
import { Fade, Slide } from 'react-reveal';
import '../App.css';

function Home() {
  return (
    <div className="bg-black text-white">
      <section className="flex flex-col md:flex-row items-center py-16 px-6 lg:ml-64 md:w-12/12 md:ml-24">
        <Fade>
          <div className="intro bg-black w-full md:w-8/12 py-10 px-6 md:pl-12">
            <h4 className="text-orange-default font-bold text-xl">Hi, I'm a</h4>
            <h1 className="text-white text-3xl md:text-4xl lg:text-5xl font-bold pt-2">
              Fullstack Web Developer
              <br className="md:hidden" /> and Designer
            </h1>
            <p className="text-white font-medium mt-6">
              Welcome to my portfolio! I'm UHIRIWE Anne Leslie,
              <br className="md:hidden" />
              a passionate Rwandan fullstack web developer and designer.
            </p>
            <Link to="/about">
              <button className="bg-orange-default hover:bg-orange-600 text-white mt-8 px-4 py-2 font-semibold rounded transition duration-300">
                Learn More
              </button>
            </Link>
          </div>
        </Fade>
      </section>
<Slide bottom>
      <ProjectGrid />
</Slide>
      <section className="lg:p-20">
        <Slide bottom>
          <ReachMe />
        </Slide>
      </section>
    </div>
  );
}

export default Home
